<template>
  <div class="px-4">
    <div class="max-w-6xl">
      <div class="my-3 p-4 border rounded-lg max-w-sm">
        <p class="text-xs font-semibold uppercase mb-2">Admin Account</p>
        <p class="text-sm"> {{ adminData.show_admin.first_name }} {{ adminData.show_admin.last_name }}</p>
        <p class="text-sm">{{ adminData.show_admin.email }}</p>
        <!--<a class="text-sm link">Request to change</a>-->
      </div>
      <div class="sm:flex sm:items-center pb-5 border-b">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Users</h1>
          <p class="mt-2 text-sm text-gray-700">A list of all users that have admin access for this event. Check the boxes to give users access to the different admin sections.</p>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none" v-if="adminData.event_user_access.length">
          <button @click="addUserClicked" type="button" class="block rounded-md bg-blue-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">Add user</button>
        </div>
      </div>

      <div class="mt-8 flow-root">
        <div class="-mx-4 -my-2 overflow-x-auto_ sm:-mx-6 lg:-mx-8 ">
          <div class="inline-block_ min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div v-if="adminData.event_user_access.length" class="overflow-hidden_ shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-300">
                <thead class="bg-gray-100">
                  <tr>
                    <th scope="col" class="py-3 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Name</th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-semibold text-gray-900">Email</th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-semibold text-gray-900">Event</th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-semibold text-gray-900">Shows</th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-semibold text-gray-900">Sponsors</th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-semibold text-gray-900">Exhibitors</th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-semibold text-gray-900">Check In</th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-semibold text-gray-900">Show Books</th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-semibold text-gray-900">Results</th>
                    <th scope="col" class="px-3 py-3 text-left text-sm font-semibold text-gray-900">Financials</th>
                    <th scope="col" class="relative py-3 pl-3 pr-4 sm:pr-6">
                      <span class="sr-only">Edit</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                  <tr v-for="person in adminData.event_user_access" :key="person.email">
                    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{ person.first_name }} {{ person.last_name }}</td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-600">{{ person.email }}</td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">
                      <input v-model="person.event_access" @change="updateUserAccess(person)" id="comments" aria-describedby="comments-description" name="event_access" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600">
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">
                      <input v-model="person.shows_access" @change="updateUserAccess(person)" id="comments" aria-describedby="comments-description" name="shows_access" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600">
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">
                      <input v-model="person.sponsors_access" @change="updateUserAccess(person)" id="comments" aria-describedby="comments-description" name="sponsor_access" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600">
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">
                      <input v-model="person.exhibitors_access" @change="updateUserAccess(person)" id="comments" aria-describedby="comments-description" name="exhibitor_access" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600">
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">
                      <input v-model="person.check_in_access" @change="updateUserAccess(person)" id="comments" aria-describedby="comments-description" name="check_in_access" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600">
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">
                      <input v-model="person.show_books_access" @change="updateUserAccess(person)" id="comments" aria-describedby="comments-description" name="show_books_access" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600">
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">
                      <input v-model="person.results_access" @change="updateUserAccess(person)" id="comments" aria-describedby="comments-description" name="results_access" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600">
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">
                      <input v-model="person.financial_access" @change="updateUserAccess(person)" id="comments" aria-describedby="comments-description" name="financial_access" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600">
                    </td>
                    <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                      <a href="#" class="btn-link" @click="removeUserClicked(person)"
                        >Delete<span class="sr-only">, {{ person.name }}</span></a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
                <div class="text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mx-auto h-12 w-12 text-gray-400">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
                  </svg>
                  <h3 class="mt-2 text-sm font-medium text-gray-900">No Users</h3>
                  <p class="mt-1 text-sm text-gray-600">Get started by manually adding a sponsor.</p>
                  <div class="mt-6">
                    <button @click="addUserClicked" type="button" class="rounded-md bg-blue-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">Add user</button>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal title='Add User' ref="addUser">
      <div v-if="!loading">
        <div v-if="foundUser">
          <div class="p-4 border rounded-md">
            <p class="text-xl mb-2">User Found:</p>
            <p>{{ foundUser.first_name }} {{ foundUser.last_name }}</p>
            <p>{{ foundUser.email }} </p>
            <div class="flex justify-start space-x-2 items-center border-t pt-2 mt-4">
              <button @click="addUser" type="button" class="block rounded-md bg-green-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600">Add User</button>
              <button class="btn-link" @click="clearSerach">New Search</button>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="searchMade">
            No User Found for <strong>{{ searchEmail }}</strong>, retype email to seach again.
          </div>
          <div class="mt-6 flex">
            <label for="email" class="sr-only">Email address:</label>
            <input v-model="email" v-on:keyup.enter="findUser" type="email" name="email" id="email" class="block w-full rounded-md border px-2 py-1.5 text-gray-900 shadow-sm borer-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" placeholder="Enter an email">
            <button @click="findUser" class="ml-4 flex-shrink-0 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Find User</button>
          </div>
          <p class="mt-1 text-base text-gray-600">Type in an email to search for an <strong>existing</strong> user to add to your event.</p>
          <p class="mt-6 text-sm text-gray-600 font-semibold">REMINDER - In order to give another user access to your show, their account/login must already exist in Showman.</p>
        </div>

      </div>
      <template v-else>
        <vue-simple-spinner size="large" message="Searching For Users" line-fg-color="orange"/>
      </template>
      <div slot="modal-footer" class="space-x-2">
        <button class="btn-link" @click="$refs.addUser.hide()">Cancel</button>
      </div>
    </b-modal>

  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      searchMade: false,
      searchEmail: null,
      foundUser: null,
      newUserAccess: {},
      loading: false
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.user
    },
    adminData () {
      return this.$store.state.admin.adminData
    }
  },
  methods: {
    addUserClicked () {
      this.$refs.addUser.show()
      this.searchMade = false
      this.foundUser = null
    },
    findUser () {
      if (!(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(this.email))) {
        this.notie.alert({
          type: 3,
          text: `Please enter a valid email address when looking up exhibitor account.`
        })
        return
      }
      this.loading = true
      this.searchEmail = this.email
      this.$store.dispatch('checkEmail', {email: this.email})
        .then(response => {
          this.searchMade = true
          setTimeout(() => {
            if (response.data.data) {
              this.foundUser = response.data.data
            } else {
              this.foundUser = null
            }
            this.loading = false
          }, 500)
        })
    },
    addUser () {
      let eventUserAccess = {
        user_id: this.foundUser.user_id,
        event_id: this.adminData.event.event_id,
        email: this.foundUser.email,
        first_name: this.foundUser.first_name,
        last_name: this.foundUser.last_name
      }
      this.$store.state.apiInstance.post('/data/eventUserAccess', eventUserAccess)
        .then(result => {
          eventUserAccess.id = result.data.data.id
          this.$store.commit('addAdminUserAccess', eventUserAccess)
          this.$refs.addUser.hide()
        })
    },
    clearSerach () {
      this.searchMade = false
      this.foundUser = null
      this.searchEmail = null
      this.email = null
    },
    removeUserClicked (toDelete) {
      if (window.confirm('Are you sure you want to remove admin access for this user?')) {
        this.removeUser(toDelete)
      }
    },
    removeUser (toDelete) {
      this.$store.state.apiInstance.delete(`/data/eventUserAccess/${toDelete.id}`)
        .then(() => {
          this.$store.commit('removeAdminUserAccess', toDelete)
        })
    },
    updateUserAccess (person) {
      this.$store.state.apiInstance.put(`/data/eventUserAccess/${person.id}`, person)
        .then(() => {
        })
    }
  }
}
</script>

<style>

</style>
